import { useState } from 'react';
import { Speaker } from 'lucide-react';
import { Main } from './Hublang/Pengaduan/Main';
import { Teknik } from './Hublang/Pengaduan/Teknik';

export default function DashboardPengaduan() {
  const [menuStatus, setMenuStatus] = useState("main");
    
  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Speaker className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Pengaduan</h1>
                {/* <p className="text-gray-600">Kelola data karyawan dan informasi kontrak</p> */}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <button
                  onClick={() => setMenuStatus("main")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'main' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'main' ? 'blue' : 'gray'}-200 transition-colors`}
                >
                  Main
                </button>

                <button
                  onClick={() => setMenuStatus("teknik")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'teknik' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'teknik' ? 'blue' : 'gray'}-200 transition-colors`}
                >
                  Teknik
                </button>
              </div>
            </div>
          </div>

          { menuStatus == "main" && <Main />}
          { menuStatus == "teknik" && <Teknik />}
        </div>
      </div>
    </>
  )
}
